<template>
  <div class="page-con">
    <div class="list-box common-shadow clearfix">
      <Tabs type="card">
        <TabPane v-if="isHavePermission('carInfo:checkCN')" label="入网验证">
          <check-c-n></check-c-n>
        </TabPane>
        <!-- <TabPane v-if="isHavePermission('carInfo:checkCI')" label="车主验证">
          <check-c-i></check-c-i>
        </TabPane>
        <TabPane v-if="isHavePermission('carInfo:checkYS')" label="道路运输证查询">
          <check-y-s></check-y-s>
        </TabPane>
        <TabPane v-if="isHavePermission('carInfo:checkDL')" label="车辆行驶证信息查询">
          <check-d-l></check-d-l>
        </TabPane>
        <TabPane v-if="isHavePermission('carInfo:checkAllInfo')" label="车辆完整信息查询">
          <check-all-info></check-all-info>
        </TabPane>
        <TabPane v-if="isHavePermission('carInfo:checkQI')" label="从业资格证信息查询">
          <check-q-i></check-q-i>
        </TabPane>
        <TabPane v-if="isHavePermission('carInfo:checkVRL')" label="车辆道路运输证核验">
          <check-v-r-l></check-v-r-l>
        </TabPane>
        <TabPane v-if="isHavePermission('carInfo:checkERL')" label="企业道路运输经营许可证验证">
          <check-e-r-l></check-e-r-l>
        </TabPane> -->
      </Tabs>
    </div>
  </div>
</template>
<script>
import checkCN from "./checkCN";
import checkCI from "./checkCI";
import checkYS from "./checkYS";
import checkDL from "./checkDL";
import checkAllInfo from "./checkAllInfo";
import checkQI from "@/views/carShip/checkQI";
import checkVRL from "@/views/carShip/checkVRL";
import checkERL from "@/views/carShip/checkERL";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  name: "findCarInfo",
  mixins: [getAuthOrization],
  // components: {checkCN, checkCI, checkYS, checkDL, checkAllInfo, checkQI, checkVRL, checkERL},
  components: { checkCN },

  data() {
    return {};
  },
  methods: {},
};
</script>
<style></style>
